export default __webpack_public_path__ + "static/media/projectfeature5.a497adea.png";